import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';

import moment from 'moment';
import { isEmpty } from 'lodash';

import { Tabs } from 'antd-mobile';

import { onHistoryPush, dateFormat, formatDate, goBack } from '@/utils/utils';
import { VoucherStateList, CouponStateOption } from '@/utils/constants';

import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';

import voucherDefault from '@/assets/images/point/defaultVoucherImg.png';
import circleTop from '@/assets/images/circle_top.png';
import circleBottom from '@/assets/images/circle_bottom.png';
import noDataImg from '@/assets/images/point/nodata.png';

import { BaseSpin, Clickable } from '@/components';
import Header from '../Header';
import styles from './index.less';

const { VALID, EXPIRED, USED } = CouponStateOption;

const MyVoucher = props => {
  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();

  const { getConfigParamDXP, qryVoucherListDXP, loading } = props;

  const [voucherList, setVoucherList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(VoucherStateList[0]);
  const { needGoBack } = history.location.query;

  const qryMyVoucherList = couponState => {
    const payload = { paramCodeList: ['lms.point.his.duration'] };
    getConfigParamDXP(payload).then(() => {
      let voucherPayload = {
        startDate: dateFormat(moment().add(1, 'days').subtract(1, 'months').locale('en')),
        endDate: dateFormat(moment().add(1, 'days').locale('en')),
        pageIndex: 1,
        pageSize: 100,
        // couponState,
        partyType: 'INDIVIDUAL',
      };
      if (couponState) {
        voucherPayload = { ...voucherPayload, couponState };
      }
      qryVoucherListDXP(voucherPayload).then(voucherListTemp => {
        setVoucherList(voucherListTemp);
      });
    });
  };

  const handleGoToDetail = item => {
    onHistoryPush('/pointshop/voucherDetail', {
      couponInstId: item.couponInstId,
      couponSn: item.couponSn,
    });
  };

  const handleSearchType = key => {
    const tab = VoucherStateList.find(it => it.value === key);
    setSelectedTab(tab);
    qryMyVoucherList(tab?.value);
  };

  useEffect(() => {
    qryMyVoucherList(null);
  }, []);

  const goHome = () => {
    if (needGoBack) {
      history.goBack();
      return;
    }
    goBack();
  };

  const renderTime = (item, isVaild, isExpried, isUsed) => {
    const timeObj = {};
    if (isVaild) {
      const today = moment();
      // 计算相差的天数
      const daysRemaining = moment(item.expDate).diff(today, 'days') || 0;
      if (daysRemaining > 7) {
        timeObj.dataText = `${GCPI18n({ id: 'lb_redeemable_till' })} ${formatDate(item.expDate)}`;
      } else {
        timeObj.className = styles.waring;
        timeObj.dataText = `${GCPI18n({
          id: 'lb_my_rewards_all_card_expiring_in',
        })} ${daysRemaining} ${GCPI18n({ id: 'lb_my_rewards_all_card_days' })}`;
      }
    }
    if (isExpried) {
      timeObj.className = styles.waring;
      timeObj.dataText = GCPI18n({ id: 'lb_point_my_voucher_expired' });
    }
    if (isUsed) {
      timeObj.dataText = GCPI18n({ id: 'lb_fully_redeemed' });
    }
    return timeObj;
  };

  return (
    <div className={styles.myVoucherWrap}>
      <Header
        title={GCPI18n({
          id: 'lb_point_my_voucher',
        })}
        goHome={goHome}
      />
      <div className={styles.voucherType}>
        <Tabs onChange={handleSearchType}>
          {VoucherStateList.map(it => (
            <Tabs.Tab key={it.value} title={GCPI18n({ id: it.labelKey })} />
          ))}
        </Tabs>
      </div>
      {isEmpty(voucherList) && (
        <div className={styles.noData}>
          <div className={styles.imgBox}>
            <img src={noDataImg} alt="" />
          </div>
          <div className={styles.tipBox}>
            <p className={styles.title}>{GCPI18n({ id: selectedTab?.noDataTitleKey })}</p>
            <p className={styles.tip}>{GCPI18n({ id: selectedTab?.noDataTipKey })}</p>
          </div>
        </div>
      )}
      {!isEmpty(voucherList) && (
        <div className={styles.voucherList}>
          <BaseSpin spinning={loading}>
            {voucherList.map(item => {
              const isVaild = item.couponState === VALID; // 可使用
              const isExpried = item.couponState === EXPIRED; // 过期
              const isUsed = item.couponState === USED; // 已使用
              const { dataText, className } = renderTime(item, isVaild, isExpried, isUsed);
              let itemClassname = '';
              if (isExpried) {
                itemClassname = styles.expriedItem;
              }
              if (isUsed) {
                itemClassname = styles.usedItem;
              }
              return (
                <Clickable
                  className={`${styles.voucherItem} ${itemClassname}`}
                  onClick={() => handleGoToDetail(item)}
                >
                  <div className={styles.bgCard}>
                    <div className={styles.circleTop}>
                      <img src={circleTop} alt="" className={styles.circleTop} />
                    </div>
                    <div className={styles.line} />
                    <div className={styles.circleBottom}>
                      <img src={circleBottom} alt="" className={styles.circleBottom} />
                    </div>
                  </div>
                  <div className={styles.content}>
                    <div className={styles.left}>
                      <img src={item.couponImageUrl || voucherDefault} alt="" />
                      {isExpried && (
                        <div className={styles.expried}>
                          {GCPI18n({ id: 'lb_point_my_voucher_expired' })}
                        </div>
                      )}
                    </div>
                    <div className={styles.right}>
                      <div className={styles.name}>{item.couponName}</div>
                      <div className={`${styles.time} ${className}`}>{dataText}</div>
                      {/* 与UI讨论过，暂时屏蔽 couponSn */}
                      {/* {
                            item.couponSn && (
                              <div className={styles.code}>
                                <img src={gift} alt="" />
                                {GCPI18n({
                                  id: 'lb_point_my_voucher_code',
                                })}
                                : {item.couponSn}
                              </div>
                            )
                          } */}
                    </div>
                  </div>
                </Clickable>
              );
            })}
            <div className={styles.listEnd}>
              <div className={styles.line} />
              <div className={styles.endText}>
                {GCPI18n({ id: 'lb_rewards_the_end_of_the_list' })}
              </div>
              <div className={styles.line} />
            </div>
          </BaseSpin>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
  qryVoucherListDXP: payload =>
    dispatch({
      type: 'index/qryVoucherListDXP',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading }) => ({
    pointDetail: pointShop.pointDetail,
    loading: loading.effects['index/qryVoucherListDXP'] || false,
  }),
  mapDispatchToProps,
)(MyVoucher);
